import { message } from "antd";

/**
 * Thin wrappers around antd's static `message` API with the scanner toast
 * styling (index.css). Kept in one place so every flow surfaces server strings
 * consistently.
 */
export const toastSuccess = (content: string): void => {
  message.open({
    type: "success",
    content,
    className: "scanner-toast-success",
    duration: 2,
  });
};

export const toastError = (content: string): void => {
  message.open({
    type: "error",
    content,
    className: "scanner-toast-error",
    duration: 3,
  });
};
